const markerIconIdle = require('../../images/Map_DL.png');
const markerIconActive = require('../../images/Map_DL_selected.png');

import Vue from 'vue';
import '../vue-components/contractor-card';
import '../vue-components/contractor-search-filter';

Vue.directive('visible', function(el, binding) {
	el.style.visibility = binding.value ? 'visible' : 'hidden';
});

export default {
  init() {
    this.vue = new Vue({
      el: '#vue-search',

      data: {
        allContractors: [],
        selectedContractor: undefined,

        radius: {
          current:10000,
          min: 5000,
          max: 100000,
          active: false,
        },

        tab: 'map',

        map: {
          map: undefined,
          circle: undefined,
          origin: new window.google.maps.LatLng(
            ajax_args.search_map_settings.lat,
            ajax_args.search_map_settings.lng
          ),
          clusterer: undefined,
        },

        autocomplete: undefined,
        allFilters: [],
        selectedFilter: [],

        showFilters: false,
        popout: null,
      },

      computed: {
        'radiusText': function() {
          return (this.radius.current / 1000 ).toFixed(0);
        },

        'contractorsByDistance': function() {
          if(!this.radius.active) return this.allContractors;
          return this.allContractors.filter(contractor => {
            return contractor.distance < this.radius.current; 
          });
        },

        'contractorsByFilter': function() {
          if(this.selectedFilter.length < 1) return this.allContractors;
          return this.allContractors.filter(contractor => {
            return contractor.services.filter(x => this.selectedFilter.includes(x)).length >= this.selectedFilter.length;
          });
        },

        'filteredContractors': function() {
          return this.contractorsByDistance.filter(a => {
            return this.contractorsByFilter.includes(a);
          });
        },

        'filterText': function() {
          return this.selectedFilter.map(selected => {
            return this.allFilters.find(candidate => candidate.key == selected).title;
          }).join(', ');
        },
      },

      watch: {
        'radius.current': function(val) {
          this.recenter(val);
        },

        'tab': function() {
          if(this.radius.active) {
            this.allContractors.sort((a, b) => {
              return a.distance - b.distance;
            })
          } else {
            this.allContractors.sort((a, b) => {
              return a.sort - b.sort;
            })
          }
          
          Vue.nextTick(() => {
            if(this.radius.active) this.recenter(this.radius.current);
          })
        },

        'radius.active': function() {
          this.map.circle.setVisible(this.radius.active > 0);
          this.styleSlider();
        },

        'filteredContractors': function() {
          this.allContractors.forEach(contractor => {
            contractor.marker.setVisible(this.filteredContractors.includes(contractor));
          });
        },

        'map.origin': function() {
          this.map.circle.setCenter(this.map.origin);
          this.map.map.setCenter(this.map.origin);

          this.calculateDistances();
          
        },

        'selectedContractor': function() {
          this.allContractors.forEach(contractor => {
            contractor.marker.setIcon(markerIconIdle);
          });

          if(this.selectedContractor) {
            this.selectedContractor.marker.setIcon(markerIconActive);
          }
        },
      },

      methods: {
        recenter: function(val) {
          this.map.circle.setRadius(Number(val));
          this.map.map.fitBounds(this.map.circle.getBounds());
          this.radius.active = val > 0;

          this.styleSlider();
        },

        styleSlider: function() {
          const el = this.$refs.distance;
          el.style.setProperty('--min', el.min === '' ? '0' : el.min);
          el.style.setProperty('--max', el.max === '' ? '100' : el.max);
          el.style.setProperty('--value', el.value);
        },

        toggleFilters: function() {
          this.data.showFilters = this.data.showFilters;
        },

        modalClick: function(event) {
          if(!this.$refs.filterContainer.contains(event.target)) {
            this.showFilters = false;
          }
        },

        clearFilters: function(event) {
          event.preventDefault();
          this.selectedFilter = [];
        },

        resetFilters: function() {
          this.selectedFilter = [];
          this.selectedContractor = undefined;
          this.map.origin = new window.google.maps.LatLng(
            ajax_args.search_map_settings.lat,
            ajax_args.search_map_settings.lng
          );
          this.map.map.setZoom(ajax_args.search_map_settings.zoom);
          this.closeRadius();
        },

        closeRadius: function() {
          this.radius.active = false;
          this.$refs.place.value = '';
        },

        closeCard: function() {
          this.selectedContractor = undefined;
        },

        calculateDistances: function() {
          this.allContractors.forEach(contractor => {
            const distance = window.google.maps.geometry.spherical.computeDistanceBetween(
              this.map.origin, contractor.marker.position);
            contractor.distance = distance;
          });
        },

        createMarkers: function() {
          this.allContractors.map((contractor) => {
            const marker = new window.google.maps.Marker({
              position: new window.google.maps.LatLng(contractor.maps.lat, contractor.maps.lng),
              label: '', //contractor.name,
              icon: markerIconIdle,
              map: this.map.map,
            });

            marker.addListener('click', () => {
              this.selectedContractor = contractor;
            });

            contractor.marker = marker;
            return marker;
          });
        },

        processResults: function(result) {
          this.allFilters = result.services.map(service => {
            service.key = service.filter;
            return service;
          });

          this.selectedFilter = this.allFilters
            .filter(value => ajax_args.contractor_search_parameters.includes(value.key))
            .map(value => value.key);

          result.contractors.forEach(contractor => {
            contractor.services = contractor.services.map(service => String(service));
            contractor.sort = Math.random(); 
          });

          this.allContractors = result.contractors.filter((contractor) => {
            if(contractor.maps) return true;
            return false;
          });
          
          
          this.createMarkers();
          this.calculateDistances();
        },
      },

      mounted: function() {
        document.addEventListener('click', this.modalClick);

        this.map.map = new window.google.maps.Map(document.getElementById('map'), {
          center: this.map.origin,
          zoom: ajax_args.search_map_settings.zoom,
          mapTypeControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          clickableIcons: false,
        });

        this.map.map.addListener('center_changed', () => {
          this.selectedContractor = undefined;
        });

        this.map.circle = new window.google.maps.Circle({
          strokeColor: '#073070',
          strokeOpacity: 1.0,
          strokeWeight: 1,

          fillColor: '#073070',
          fillOpacity: 0.14,

          map: this.map.map,
          center: this.map.map.center,
          radius: this.radius.current,
          visible: this.radius.active,
        });

        // this.map.clusterer = new MarkerClusterer(this.map.map, [], {
        //   imagePath:
        //     'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
        // });
        // this.map.clusterer.setIgnoreHidden(true)
        // window.clusterer = this.map.clusterer;

        this.autocomplete = new window.google.maps.places.Autocomplete(this.$refs.place, {
          componentRestrictions: { country: ['de'] },
          fields: ['geometry'],
          origin: this.map.origin,
          types: ['geocode'],
        });

        this.autocomplete.addListener('place_changed', () => {
          this.map.origin = this.autocomplete.getPlace().geometry.location;
          this.map.map.fitBounds(this.map.circle.getBounds());
          this.radius.active = true;
          this.calculateDistances();
        });

        $('p[data-filter]').each((i, el) => {
          $(el).on('click', () => {
            this.selectedFilter = [String($(el).data('filter'))];
          });
        });

      },

    });

    this.loadContractors();
  },

  loadContractors() {
    const sendData = {
      'dataType': 'json',
      'action': 'get_contractors',
      'county': '515',
    };

    $.ajax({
      type: 'POST',
      data: sendData,
      url: ajax_args.url,
      success: (response) => {
        const result = JSON.parse(response);
        this.vue.processResults(result);
      },
      error: function () {
        console.log('error');
      },
    });
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contractor-search.js